import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const ReviewPage = lazy(() => import('../pages/review/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/review',
    element: <ReviewPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
